import React, { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauth, object = authed
  const [token, setToken] = useState(() => localStorage.getItem("gps_token"));

  useEffect(() => {
    let active = true;
    if (!token) {
      setUser(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => active && setUser(r.data))
      .catch(() => {
        if (!active) return;
        localStorage.removeItem("gps_token");
        setToken(null);
        setUser(false);
      });
    return () => { active = false; };
  }, [token]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("gps_token", r.data.token);
    localStorage.setItem("gps_user", JSON.stringify(r.data.user));
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("gps_token");
    localStorage.removeItem("gps_user");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy">
        <div className="text-ink-secondary font-heading uppercase tracking-widest">Checking session…</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

export function AdminOnlyRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/admin/games" replace />;
  return children;
}
